export enum RolesEnum {
	INFORMATION_SECURITY = "INFORMATION_SECURITY",
	ACCOUNT_SERVICE = "ACCOUNT_SERVICE",
	MIDDLE_OFFICE_ANALYST = "MIDDLE_OFFICE_ANALYST",
	BANKER = "BANKER",
	HUB_SERVICE = "HUB_SERVICE",
	ADMINISTRATOR = "ADMINISTRATOR",
	MIDDLE_OFFICE_MANAGER = "MIDDLE_OFFICE_MANAGER",
	BANKING_SERVICE = "BANKING_SERVICE",
	COMPLIANCE_OFFICE_MANAGER = "COMPLIANCE_OFFICE_MANAGER",
	CREDIT_SERVICES = "CREDIT_SERVICES",
}
